import React, { useState } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';

const faqData = [
  {
    question: 'What is Polycystic Kidney Disease (PKD)?',
    answer: 'Polycystic Kidney Disease (PKD) is a genetic disorder characterized by the growth of numerous cysts in the kidneys. These cysts can enlarge the kidneys and interfere with their function, potentially leading to kidney failure.'
  },
  {
    question: 'Does PKD always lead to kidney failure?',
    answer: 'Not everyone with PKD will experience kidney failure. The progression of the disease varies greatly among individuals. Many people manage their condition effectively with medical care, lifestyle changes, and treatments that can slow cyst growth and preserve kidney function for many years.'
  },
  {
    question: 'What other complications can PKD cause?',
    answer: 'Besides kidney problems, PKD can cause complications in other parts of the body. These may include high blood pressure, cysts in the liver, heart valve problems, and an increased risk of brain aneurysms. Regular monitoring is crucial.'
  },
  {
    question: 'How is PKD diagnosed?',
    answer: 'PKD is typically diagnosed using imaging tests like ultrasound, CT scans, or MRI, which can detect cysts in the kidneys. A family medical history is also important. In some cases, genetic testing may be used to confirm the diagnosis.'
  },
  {
    question: 'Is there a cure for PKD?',
    answer: 'Currently, there is no cure for PKD. However, treatments are available to manage symptoms and slow the progression of the disease. Research is ongoing, with new therapies being developed to target the underlying causes of cyst growth.'
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="section faq-section">
      <div className="container">
        <h2 className="section-title">FAQ’s</h2>
        <div className="faq-container">
          {faqData.map((item, index) => (
            <div className="faq-item" key={index}>
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                <p>{item.question}</p>
                <span>{openIndex === index ? <FaMinus /> : <FaPlus />}</span>
              </div>
              <div className={`faq-answer ${openIndex === index ? 'open' : ''}`}>
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;